import { $window } from '../../helpers/globalVars';
import { customDots } from '../../helpers/slick';

const handler = ( $ ) => {

	$('.block-video-cards .block-cards').each( function() {

		const $carousel = $( this );
		const options = {
			infinite: false,
			arrows: false,
			dots: true,
			slideToShow: 1,
			touchThreshold: 10,
			speed: 150,
		};

		if ( $carousel.find('.block-card').length == 1 ) {
			options.dots = false;
		}

		$carousel.on( 'init', customDots );

		const doInit = function() {
			if( $window.width() >= 992 && $carousel.hasClass('is-initialized') ) {
				$carousel.removeClass('is-initialized').slick('unslick');
			} else if( $window.width() <= 991 && ! $carousel.hasClass('is-initialized')) {
				$carousel.addClass('is-initialized').slick( options );
			}
		}

		let resizeTimeout;
		$window.on('resize', function() {

			clearTimeout( resizeTimeout );
			resizeTimeout = setTimeout( doInit, 100 );

		});

		doInit();

	});

};

( ( $ ) => {
	$( handler );
} )( jQuery );
